import { useState } from 'react';

type SetValue<T> = (value: T | ((val: T) => T)) => void;

export function useStateLocalStorage<T>(
  key: string,
  initialValue: T
): [T, SetValue<T>] {
  const [state, setState] = useState<T>(() => {
    console.log(
      `Initializing localStorage key "${key}" with value:`,
      initialValue
    );
    if (typeof window === 'undefined') {
      return initialValue;
    }
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.warn(`Error reading localStorage key "${key}":`, error);
      return initialValue;
    }
  });

  return [
    state,
    (value: T | ((val: T) => T)) => {
      try {
        const valueToStore = value instanceof Function ? value(state) : value;
        console.log(`Setting localStorage key "${key}" to:`, valueToStore);
        setState(valueToStore);
        if (typeof window !== 'undefined') {
          window.localStorage.setItem(key, JSON.stringify(valueToStore));
        }
      } catch (error) {
        console.warn(`Error setting localStorage key "${key}":`, error);
      }
    }
  ];
}
